export interface TourInsight {
  description: string
  title: string
}
